import React from "react";
import { ExcelColorIcon, FilesPdfColoredIcon, NotesIcon, PowerPointColorIcon, WordIcon } from "@fluentui/react-northstar";

export function getFileColor(category: string) {
    switch (category) {
        case "doc":
        case "docx":
            return "#0078D4";
        case 'pptx':
        case 'ppt':
        case 'powerpoint':
            return '#FF7752';
        case 'xls':
        case 'xlsx':
            return '#217346';
        case 'pdf':
            return '#F01300';
        default:
            return "#0078D4"
    }
}
export function getIconColor(category: string) {
    switch (category) {
        case "doc":
        case "docx":
            return "#0078D4";
        case 'pptx':
        case 'ppt':
        case 'powerpoint':
            return '#B7472A';
        case 'xls':
        case 'xlsx':
            return '#217346';
        case 'pdf':
            return '#F01300';
        default:
            return "#0078D4"

    }
}

export function getCategory(fileExtension: string, mimeType: string) {
    let category = "none";
    switch (fileExtension) {
        case "btca":
            category = "app";
            break;
        case "btc":
        case "btcd":
        case "btcp":
            category = "btc";
            break;
        case "cad":
        case "dwg":
        case "dxf":
            category = "cad";
            break;
        case "kml":
        case "kmz":
            category = "earthviewer";
            break;
        case "mobi":
            category = "ebook";
            break;
        case "epub":
            category = "epub";
            break;
        // form - btcf
        case "btcf":
            category = "form";
            break;
        case "ibook":
            category = "ibook";
            break;
        case "ipa":
            category = "ipa";
            break;
        case "key":
            category = "keynote";
            break;
        case "numbers":
            category = "numbers";
            break;
        case "oomph":
            category = "oomph";
            break;
        case "pages":
            category = "pages";
            break;
        // project
        case "mpp":
            category = "project";
            break;

        // prov
        case "prov":
            category = "prov";
            break;

        // rtfd
        case "rtfd":
            category = "rtfd";
            break;

        // scrollmotion
        case "scrollmotion":
            category = "scrollmotion";
            break;

        // twixl
        case "twixl":
            category = "twixl";
            break;

        // vcard
        case "vcf":
            category = "vcard";
            break;

        case "vdw":
        case "vdx":
        case "vsd":
        case "vsdx":
        case "vss":
        case "vst":
        case "vsx":
        case "vt":
            category = "visio";
            break;
        case "xls":
        case "xlsx":
            category = "excel";
            break;
        case "png":
        case "jpg":
        case "jpeg":
        case "bmp":
            category = "image";
            break;
        case "pdf":
            category = "pdf";
            break;
        case "ppt":
        case "pptx":
        case 'powerpoint':
            category = "ppt";
            break;
        case "doc":
        case "docx":
            category = "word";
            break;
        case "rtf":
            category = "rtf";
            break;
        case "txt":
            category = "txt";
            break;
        default:
            category = "none";
            break;
    }
    if (mimeType.indexOf("video") >= 0) {
        category = "video";
    }
    if (mimeType.indexOf("image") >= 0) {
        category = "image";
    }

    return category;
}



export function getIconName(category: string) {
    switch (category) {
        case "doc":
        case "docx":
            return "WordDocument";
        case 'pptx':
        case 'ppt':
        case 'powerpoint':
            return 'PowerPointDocument';
        case 'xls':
        case 'xlsx':
            return 'ExcelDocument';
        case 'pdf':
            return 'PDF';
        default:
            return "TagUnknown12Mirror"

    }
}

export function getIcon(category: string) {
    switch (category) {
        case "doc":
        case "docx":
        case "word":
            return <WordIcon size={'largest'} style={{color: '#6264A7'}} />;
        case 'pptx':
        case 'ppt':
        case 'powerpoint':
            return <PowerPointColorIcon size={'largest'} style={{color: '#6264A7'}} />;
        case 'xls':
        case 'xlsx':
            return <ExcelColorIcon size={'largest'} style={{color: '#6264A7'}} />;
        case 'pdf':
            return <FilesPdfColoredIcon size={'largest'} style={{color: '#6264A7'}} />;
        default:
            return null;

    }
}